import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export function getToken() {
  return localStorage.getItem('token');
}

export async function request(endpoint: string, method:string='GET', body?: object, useAuth?: boolean=true) {
  const requestConf: RequestInit = {
    method: method,
    headers: {
      'Content-Type': 'application/json',
    },
  };

  if(useAuth){
    const accessToken = getToken();

    if (accessToken) {
      (requestConf.headers as Record<string, string>).Authorization = `Bearer ${accessToken}`;
    }
  }

  if(body){
    requestConf.body = JSON.stringify(body);
  }

  const response = await fetch(`${import.meta.env.VITE_API_URL}${endpoint}`, requestConf);

  if (!response.ok) {
    // Attempt to parse JSON error message, otherwise fallback to status text
    const errorData = await response.json().catch(() => ({ ...response }));
    throw new Error(errorData.error || errorData.message || response.statusText);
  }
  const data  = await response.json();
  return data;
}

export function formatDate(date: Date) {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
};


export function getDateRange(numDays: number, offset: number = 0) {
  const endDate = new Date();
  endDate.setDate(endDate.getDate() - offset + 1);

  const startDate = new Date();
  startDate.setDate(startDate.getDate() - numDays);

  return {
    startDate: formatDate(startDate),
    endDate: formatDate(endDate)
  };
}

export function formatShortDate(date: string) {
  if (!date) return 'Never';

  const d = new Date(date);

  const formatted = new Intl.DateTimeFormat("en-US", {
    month: "short",
    day: "2-digit",
    year: "numeric",
  }).format(d);

  return formatted
}

export function countDownDate(date: string): string {
  const target = new Date(date).getTime();
  const now = Date.now();

  const diffMs = target - now;
  const days = Math.max(0, Math.ceil(diffMs / (1000 * 60 * 60 * 24)));

  return days === 1 ? "1 day" : `${days} days`;
}

